/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  GetApiSmsTemplateList200,
  GetApiSmsTemplateListParams,
  GetApiSmsTemplatePartialSchemaList200,
  GetApiSmsTemplateSchemaList200,
  NotFoundErrorResponse,
  PostApiSmsTemplateCustomPreview200,
  PutApiSmsTemplateEdit400,
  PutApiSmsTemplateEditPartial400,
  SmsTemplateApiResource,
  SmsTemplateClonePartialRequest,
  SmsTemplateCloneRequest,
  SmsTemplateCustomPreviewRequest,
  SmsTemplateEditPartialRequest,
  SmsTemplateRequest,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiSmsTemplateListResponse200 = {
  data: GetApiSmsTemplateList200
  status: 200
}

export type getApiSmsTemplateListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiSmsTemplateListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSmsTemplateListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiSmsTemplateListResponseSuccess = (getApiSmsTemplateListResponse200) & {
  headers: Headers;
};
export type getApiSmsTemplateListResponseError = (getApiSmsTemplateListResponse400 | getApiSmsTemplateListResponse401 | getApiSmsTemplateListResponse403) & {
  headers: Headers;
};

export type getApiSmsTemplateListResponse = (getApiSmsTemplateListResponseSuccess | getApiSmsTemplateListResponseError)

export const getGetApiSmsTemplateListUrl = (params?: GetApiSmsTemplateListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sms-templates?${stringifiedParams}` : `/api/sms-templates`
}

export const getApiSmsTemplateList = async (params?: GetApiSmsTemplateListParams, options?: RequestInit): Promise<getApiSmsTemplateListResponse> => {
  
  return customFetch<getApiSmsTemplateListResponse>(getGetApiSmsTemplateListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiSmsTemplateCloneResponse201 = {
  data: SmsTemplateApiResource
  status: 201
}

export type postApiSmsTemplateCloneResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiSmsTemplateCloneResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiSmsTemplateCloneResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiSmsTemplateCloneResponseSuccess = (postApiSmsTemplateCloneResponse201) & {
  headers: Headers;
};
export type postApiSmsTemplateCloneResponseError = (postApiSmsTemplateCloneResponse400 | postApiSmsTemplateCloneResponse401 | postApiSmsTemplateCloneResponse403) & {
  headers: Headers;
};

export type postApiSmsTemplateCloneResponse = (postApiSmsTemplateCloneResponseSuccess | postApiSmsTemplateCloneResponseError)

export const getPostApiSmsTemplateCloneUrl = () => {


  

  return `/api/sms-templates`
}

export const postApiSmsTemplateClone = async (smsTemplateCloneRequest: SmsTemplateCloneRequest, options?: RequestInit): Promise<postApiSmsTemplateCloneResponse> => {
  
  return customFetch<postApiSmsTemplateCloneResponse>(getPostApiSmsTemplateCloneUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      smsTemplateCloneRequest,)
  }
);}


export type postApiSmsTemplateClonePartialResponse201 = {
  data: SmsTemplateApiResource
  status: 201
}

export type postApiSmsTemplateClonePartialResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiSmsTemplateClonePartialResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiSmsTemplateClonePartialResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiSmsTemplateClonePartialResponseSuccess = (postApiSmsTemplateClonePartialResponse201) & {
  headers: Headers;
};
export type postApiSmsTemplateClonePartialResponseError = (postApiSmsTemplateClonePartialResponse400 | postApiSmsTemplateClonePartialResponse401 | postApiSmsTemplateClonePartialResponse403) & {
  headers: Headers;
};

export type postApiSmsTemplateClonePartialResponse = (postApiSmsTemplateClonePartialResponseSuccess | postApiSmsTemplateClonePartialResponseError)

export const getPostApiSmsTemplateClonePartialUrl = () => {


  

  return `/api/sms-templates/partials`
}

export const postApiSmsTemplateClonePartial = async (smsTemplateClonePartialRequest: SmsTemplateClonePartialRequest, options?: RequestInit): Promise<postApiSmsTemplateClonePartialResponse> => {
  
  return customFetch<postApiSmsTemplateClonePartialResponse>(getPostApiSmsTemplateClonePartialUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      smsTemplateClonePartialRequest,)
  }
);}


export type postApiSmsTemplateCustomPreviewResponse200 = {
  data: PostApiSmsTemplateCustomPreview200
  status: 200
}

export type postApiSmsTemplateCustomPreviewResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiSmsTemplateCustomPreviewResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiSmsTemplateCustomPreviewResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiSmsTemplateCustomPreviewResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiSmsTemplateCustomPreviewResponseSuccess = (postApiSmsTemplateCustomPreviewResponse200) & {
  headers: Headers;
};
export type postApiSmsTemplateCustomPreviewResponseError = (postApiSmsTemplateCustomPreviewResponse400 | postApiSmsTemplateCustomPreviewResponse401 | postApiSmsTemplateCustomPreviewResponse403 | postApiSmsTemplateCustomPreviewResponse404) & {
  headers: Headers;
};

export type postApiSmsTemplateCustomPreviewResponse = (postApiSmsTemplateCustomPreviewResponseSuccess | postApiSmsTemplateCustomPreviewResponseError)

export const getPostApiSmsTemplateCustomPreviewUrl = () => {


  

  return `/api/sms-templates/preview`
}

export const postApiSmsTemplateCustomPreview = async (smsTemplateCustomPreviewRequest: SmsTemplateCustomPreviewRequest, options?: RequestInit): Promise<postApiSmsTemplateCustomPreviewResponse> => {
  
  return customFetch<postApiSmsTemplateCustomPreviewResponse>(getPostApiSmsTemplateCustomPreviewUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      smsTemplateCustomPreviewRequest,)
  }
);}


export type putApiSmsTemplateEditResponse200 = {
  data: SmsTemplateApiResource
  status: 200
}

export type putApiSmsTemplateEditResponse400 = {
  data: PutApiSmsTemplateEdit400
  status: 400
}

export type putApiSmsTemplateEditResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiSmsTemplateEditResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiSmsTemplateEditResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiSmsTemplateEditResponseSuccess = (putApiSmsTemplateEditResponse200) & {
  headers: Headers;
};
export type putApiSmsTemplateEditResponseError = (putApiSmsTemplateEditResponse400 | putApiSmsTemplateEditResponse401 | putApiSmsTemplateEditResponse403 | putApiSmsTemplateEditResponse404) & {
  headers: Headers;
};

export type putApiSmsTemplateEditResponse = (putApiSmsTemplateEditResponseSuccess | putApiSmsTemplateEditResponseError)

export const getPutApiSmsTemplateEditUrl = (id: string,) => {


  

  return `/api/sms-templates/${id}`
}

export const putApiSmsTemplateEdit = async (id: string,
    smsTemplateRequest: SmsTemplateRequest, options?: RequestInit): Promise<putApiSmsTemplateEditResponse> => {
  
  return customFetch<putApiSmsTemplateEditResponse>(getPutApiSmsTemplateEditUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      smsTemplateRequest,)
  }
);}


export type putApiSmsTemplateEditPartialResponse200 = {
  data: SmsTemplateApiResource
  status: 200
}

export type putApiSmsTemplateEditPartialResponse400 = {
  data: PutApiSmsTemplateEditPartial400
  status: 400
}

export type putApiSmsTemplateEditPartialResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiSmsTemplateEditPartialResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiSmsTemplateEditPartialResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiSmsTemplateEditPartialResponseSuccess = (putApiSmsTemplateEditPartialResponse200) & {
  headers: Headers;
};
export type putApiSmsTemplateEditPartialResponseError = (putApiSmsTemplateEditPartialResponse400 | putApiSmsTemplateEditPartialResponse401 | putApiSmsTemplateEditPartialResponse403 | putApiSmsTemplateEditPartialResponse404) & {
  headers: Headers;
};

export type putApiSmsTemplateEditPartialResponse = (putApiSmsTemplateEditPartialResponseSuccess | putApiSmsTemplateEditPartialResponseError)

export const getPutApiSmsTemplateEditPartialUrl = (id: string,) => {


  

  return `/api/sms-templates/partials/${id}`
}

export const putApiSmsTemplateEditPartial = async (id: string,
    smsTemplateEditPartialRequest: SmsTemplateEditPartialRequest, options?: RequestInit): Promise<putApiSmsTemplateEditPartialResponse> => {
  
  return customFetch<putApiSmsTemplateEditPartialResponse>(getPutApiSmsTemplateEditPartialUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      smsTemplateEditPartialRequest,)
  }
);}


export type getApiSmsTemplatePartialSchemaListResponse200 = {
  data: GetApiSmsTemplatePartialSchemaList200
  status: 200
}

export type getApiSmsTemplatePartialSchemaListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSmsTemplatePartialSchemaListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiSmsTemplatePartialSchemaListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiSmsTemplatePartialSchemaListResponseSuccess = (getApiSmsTemplatePartialSchemaListResponse200) & {
  headers: Headers;
};
export type getApiSmsTemplatePartialSchemaListResponseError = (getApiSmsTemplatePartialSchemaListResponse401 | getApiSmsTemplatePartialSchemaListResponse403 | getApiSmsTemplatePartialSchemaListResponse404) & {
  headers: Headers;
};

export type getApiSmsTemplatePartialSchemaListResponse = (getApiSmsTemplatePartialSchemaListResponseSuccess | getApiSmsTemplatePartialSchemaListResponseError)

export const getGetApiSmsTemplatePartialSchemaListUrl = (name: string,) => {


  

  return `/api/sms-templates/partial-schemas/${name}`
}

export const getApiSmsTemplatePartialSchemaList = async (name: string, options?: RequestInit): Promise<getApiSmsTemplatePartialSchemaListResponse> => {
  
  return customFetch<getApiSmsTemplatePartialSchemaListResponse>(getGetApiSmsTemplatePartialSchemaListUrl(name),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiSmsTemplateSchemaListResponse200 = {
  data: GetApiSmsTemplateSchemaList200
  status: 200
}

export type getApiSmsTemplateSchemaListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSmsTemplateSchemaListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiSmsTemplateSchemaListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiSmsTemplateSchemaListResponseSuccess = (getApiSmsTemplateSchemaListResponse200) & {
  headers: Headers;
};
export type getApiSmsTemplateSchemaListResponseError = (getApiSmsTemplateSchemaListResponse401 | getApiSmsTemplateSchemaListResponse403 | getApiSmsTemplateSchemaListResponse404) & {
  headers: Headers;
};

export type getApiSmsTemplateSchemaListResponse = (getApiSmsTemplateSchemaListResponseSuccess | getApiSmsTemplateSchemaListResponseError)

export const getGetApiSmsTemplateSchemaListUrl = (name: string,) => {


  

  return `/api/sms-templates/schemas/${name}`
}

export const getApiSmsTemplateSchemaList = async (name: string, options?: RequestInit): Promise<getApiSmsTemplateSchemaListResponse> => {
  
  return customFetch<getApiSmsTemplateSchemaListResponse>(getGetApiSmsTemplateSchemaListUrl(name),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


